import { SET_USER, SET_STATUS, LOGOUT } from "../actions/types";
import { getCurrentUser } from "../actions/auth";

const initialState = { user: null, loading: true };

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_USER:
      return {
        ...state,
        user: payload.user,
        loading: false,
      };
    case SET_STATUS:
      return {
        ...state,
        loading: false,
      };
    case LOGOUT:
      return {
        ...state,
        user: null,
        loading: false,
      };
    default:
      return state;
  }
}
